var map = {
	"./404.svg": "a14a",
	"./bug.svg": "1779",
	"./caiwu.svg": "7f54",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./delete.svg": "59a1",
	"./development-manage.svg": "6e59",
	"./dingdan.svg": "5dab",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./goods-manage.svg": "0137",
	"./icon.svg": "9d91",
	"./img-validcode.svg": "ccc6",
	"./international.svg": "17df",
	"./item-drag.svg": "169e",
	"./jishi.svg": "5b62",
	"./language.svg": "2580",
	"./list-move.svg": "a013",
	"./lock.svg": "ab00",
	"./lock1.svg": "e3d2",
	"./member-manage.svg": "0dde",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./order-manage.svg": "271f",
	"./page-manage.svg": "733e",
	"./password.svg": "2a3d",
	"./pen-leather.svg": "dad6",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./promotions-manage.svg": "2e64",
	"./qq.svg": "1430",
	"./quanxian.svg": "22cb",
	"./right-angle.svg": "728a",
	"./send.svg": "94d0",
	"./setting-manage.svg": "b0a7",
	"./shezhi.svg": "9aa1",
	"./shop-manage.svg": "7a61",
	"./shoppingCard.svg": "c6c1",
	"./shouye.svg": "d7fe",
	"./shuju.svg": "403d",
	"./sousuo.svg": "ceb2",
	"./star.svg": "708a",
	"./statistics-manage.svg": "53e1",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1f",
	"./theme.svg": "e534",
	"./tongzhi.svg": "ddfb",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./yingyong.svg": "08d6",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";